function create(message, type) {

	return `
		<div class="form__message type--${type || 'info'} u--margin-reset">
			<p>${message}</p>
		</div>
	`.trim();

}

function handleEverything($form, message, type) {

	const $formMessages = $form.find('.form__messages');
	const $formMessage = $(create(message, type));
	let isVisible;

	$formMessages.empty().append($formMessage);

	isVisible = $formMessages.get(0).getBoundingClientRect().top > 0;

	if (!isVisible) {
		$formMessage.get(0).scrollIntoView({ behavior: 'smooth' });
	}

	window.setTimeout(() => {
		$formMessage.addClass('form-message--shake');
	}, 100);

}

export default {
	create,
	handleEverything
};
